import debounce from "lodash/debounce";
import { fetchConfig } from "../helpers/fetch";
export default class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status",
    );

    this.currentItemCount = Array.from(this.quantityInputs).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.debouncedOnRemove = debounce((event) => {
      this.onRemove(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.addEventListener("remove", this.debouncedOnRemove.bind(this));

    this.quantityInputs.forEach((input) => {
      input.setAttribute("tabindex", -1);
      input.setAttribute("aria-hidden", "true");
    });
  }

  get quantityInputs() {
    return this.querySelectorAll('[name="updates[]"]');
  }

  get sectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-item-contents",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-icon",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-footer-contents",
      },
      {
        id: "main-cart-header",
        section: document.getElementById("main-cart-header").dataset.id,
        selector: "free-shipping-progress",
      },
      {
        id: "cart-recommendations",
        section: document.getElementById("cart-recommendations")?.dataset.id,
        selector: "cart-recommendations",
      },
    ];
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  onRemove = (event) => {
    this.updateQuantity(event.target.dataset.index, 0);
  };

  updateQuantity(line, quantity) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}.js`, { ...fetchConfig(), ...{ body } }) // eslint-disable-line no-undef
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateSectionHTML(parsedState);
        this.updateLiveRegions(line, parsedState.item_count);
        this.toggleEmptyClass(parsedState.item_count);
        this.maybeFocusLineItem(line);
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".c-loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors = document.getElementById("cart-errors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateSectionHTML(parsedState) {
    for (const section of this.sectionsToRender) {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      const updatedSectionElement = this.getParsedSectionElement(
        parsedState.sections[section.section],
        section.selector,
      );

      // For free shipping progress section, only update data attribute; otherwise replace section innerHTML.
      // Why? free-shipping-progress is a custom element that updates dynamically when data attributes change.
      if (elementToReplace.tagName === "FREE-SHIPPING-PROGRESS") {
        const cartTotal = updatedSectionElement.getAttribute("data-cart-total");
        elementToReplace.setAttribute("data-cart-total", cartTotal);
      } else {
        elementToReplace.innerHTML = updatedSectionElement.innerHTML;
      }
    }
  }

  getParsedSectionElement(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`);

      if (!lineItemError) return;

      lineItemError.querySelector(".c-cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value,
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  toggleEmptyClass(itemCount) {
    const cartDrawer = document.getElementById("cart-drawer");
    const cartFooter = document.getElementById("main-cart-footer");

    [this, cartDrawer, cartFooter]
      .filter(Boolean)
      .forEach((el) => el.classList.toggle("is-empty", itemCount === 0));
  }

  maybeFocusLineItem(line) {
    const lineItem = document.getElementById(`CartItem-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`))
      lineItem.querySelector(`[name="${name}"]`).focus();
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items");
    mainCartItems.classList.add("c-cart__list-block--is-loading");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .c-loading-overlay`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.remove("hidden"));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById("main-cart-items");
    mainCartItems.classList.remove("c-cart__list-block--is-loading");
  }
}
